import { AppUser } from "components/Admin/UserManager/UserStore";
import type { Role } from "components/Admin/Organizations/types/Role.type";
import RoleService from "../components/Admin/Organizations/OrganizationDetail/OrganizationRoles/Role.service";
import { ApplicationUser } from "../models/Permission/ApplicationUser";
//"../OrganizationDetail/OrganizationRoles/Role.service";
import BaseService from "./BaseService";

export type UserForSharing = {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    userName: string;
};

export type ServiceHierarchyUserResponse = {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    disabled: boolean;
    roleName: string;
};

export type AgentUserSearchResult = {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
};

export class UserService extends BaseService {
    protected urlBase: string = "api/User";

    public async getUserLoginHistory(userId: string) {
        const params = new URLSearchParams({ userId });
        const res = await this.get(params, "UserLoginHistory");

        return res;
    }

    public async updateUserProfile(appUser: AppUser) {
        const params = new URLSearchParams({});
        const res = await this.put(
            params,
            "UpdateProfile",
            JSON.stringify(appUser),
        );
        return res;
    }
    public async updatePassword(appUser: AppUser) {
        const params = new URLSearchParams({});
        const res = await this.put(
            params,
            "UpdatePassword",
            JSON.stringify(appUser),
        );
        return res;
    }
    public async adminResetPassword(appUser: AppUser) {
        const params = new URLSearchParams({});
        const res = await this.put(
            params,
            "AdminResetPassword",
            JSON.stringify(appUser),
        );
        return res;
    }

    public async getUsers(orgId: string): Promise<AppUser[]> {
        const params = new URLSearchParams({ orgId: orgId });
        const res = (await this.get(params, "GetUsers")) as AppUser[];
        return res;
    }

    public async searchUsers(
        organizationId: string,
        searchValue: string,
    ): Promise<AgentUserSearchResult[]> {
        const res = await this.post<AgentUserSearchResult[]>(
            JSON.stringify({ organizationId, searchValue }),
            new URLSearchParams({}),
            "SearchUsers",
        );
        return res;
    }

    public async getUserNames(
        organizationId: string,
    ): Promise<ApplicationUser[]> {
        const res = await this.post<ApplicationUser[]>(
            JSON.stringify({ organizationId }),
            new URLSearchParams({}),
            "UserNames",
        );
        return res;
    }

    public async getUsersForSharing(
        organizationId: string,
    ): Promise<UserForSharing[]> {
        const res = await this.post<UserForSharing[]>(
            JSON.stringify({ organizationId }),
            new URLSearchParams({}),
            "UsersForSharing",
        );
        return res;
    }

    public async getUsersByHierarchy(
        hierarchyId: string,
    ): Promise<ServiceHierarchyUserResponse[]> {
        const params = new URLSearchParams({ hierarchyId: hierarchyId });
        const res = await this.get(params, "GetUsersByHierarchy");
        return res;
    }

    public async getRoles(): Promise<Role[]> {
        const parms = new URLSearchParams({});
        const res = await this.get<Role[]>(parms, "GetRoles");
        return res;
    }
    public async getRolesByOrganizationId(orgId: string): Promise<Role[]> {
        return await RoleService.getRoles(orgId);
    }
    public async createUser(appUser: AppUser) {
        const parms = new URLSearchParams({});
        const res = await this.post(
            JSON.stringify(appUser),
            parms,
            "RegisterUser",
        );
        return res;
    }
}
